const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/planner/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { requirePermission } from '@/common/hooks/usePermissions';
import i18n from '@/common/translations/i18n';
import { readLiveFlag } from '@/common/utils/readLiveFlag';
import { itemPanelSearchSchema } from '@/features/item-panel/searchSchema';
type PermissionContext = Parameters<ReturnType<typeof requirePermission>>[0]['context'];
type PlannerBeforeLoadArgs = {
  context: PermissionContext & {
    flags: {
      plannerModuleEnabled: boolean;
    };
    flagOverrides: Partial<FlagKeys>;
    ldClient: LDClient | undefined;
  };
};
export const plannerBeforeLoad = async (args: PlannerBeforeLoadArgs) => {
  await requirePermission('edit_planner')(args);
  const plannerModuleEnabled = readLiveFlag(args.context, 'plannerModuleEnabled');
  if (!plannerModuleEnabled) {
    throw notFound();
  }
};
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(itemPanelSearchSchema),
  pendingComponent: () => null,
  beforeLoad: plannerBeforeLoad,
  staticData: {
    topNav: {
      title: i18n.t($ => $.loops.planner)
    }
  }
});